import PropTypes from 'prop-types'
import media from './mediaForm'

export default {
    id: PropTypes.number,
    countries: PropTypes.arrayOf(PropTypes.string),
    date_end: PropTypes.number,
    date_start: PropTypes.number,
    status: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.number, PropTypes.string]),
    group: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.number, PropTypes.string]),
    level_required: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.number, PropTypes.string]),
    media: PropTypes.oneOfType([PropTypes.number, PropTypes.shape(media), PropTypes.arrayOf(PropTypes.instanceOf(File))]),
    name: PropTypes.string,
    notes: PropTypes.string,
    purchase_order: PropTypes.string,
}
